/* @flow */

import React from 'react';
import Relay from 'react-relay';

import { css, merge } from 'glamor';

import { isEqual, debounce } from 'lodash';

import { GREY_E } from 'depop/styles/colors';

import Linear from 'depop/components/loaders/Linear';

function cleanFormats(formats) {
  return formats.map(format => ({
    size: format.width,
    url: format.url,
  }));
}

class Picture extends React.PureComponent {
  props: {
    picture: Object,
    lazyloadOffset: number,
    scrollDelay: number,
    title: string,
    alt: string,
    rounded: boolean,
    useLoader: boolean,
  };

  state: {
    mounted: boolean,
  };

  static defaultProps = {
    rounded: false,
    useLoader: false,
    lazyloadOffset: 0,
    scrollDelay: 250,
  };

  constructor(props) {
    super(props);
    this.loadImage = debounce(this.loadImage, 250, { leading: true });
    this.state = { mounted: false };
  }

  loadImage = () => {
    window.loadImage(this._imgContainer);
  };

  componentWillReceiveProps(nextProps) {
    const cleanedFormats = cleanFormats(this.props.picture.formats);
    const nextCleanedFormats = cleanFormats(nextProps.picture.formats);

    if (!isEqual(cleanedFormats, nextCleanedFormats)) {
      if (this && this._imgContainer) {
        this._imgContainer.innerHTML = '';
      }
    }
  }

  componentDidUpdate() {
    window.loadImage(this._imgContainer);
  }

  componentDidMount() {
    this.setState({ mounted: true });
    this.loadImage();
    window.addEventListener('resize', this.loadImage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.loadImage);
  }

  render() {
    const { picture = {}, rounded, useLoader } = this.props;
    // const ratio = picture.width / picture.height;
    const ratio = picture.height / picture.width;
    const heightPercentage = 100 * ratio;

    const baseWrapperStyles = css({
      backgroundColor: GREY_E,
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
    });

    const wrapperStyles = rounded
      ? merge(baseWrapperStyles, css({ borderRadius: '50%' }))
      : baseWrapperStyles;

    const baseImageStyles = css({
      '> img': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        verticalAlign: 'bottom',
        display: 'block',
        zIndex: 50,
      },
    });

    const imageStyles = rounded
      ? merge(
          baseImageStyles,
          css({
            '> img': { borderRadius: '50%' },
          }),
        )
      : baseImageStyles;

    return (
      <div {...wrapperStyles} style={{ paddingBottom: `${heightPercentage}%` }}>
        {useLoader &&
          this.state.mounted &&
          <div
            {...css({
              position: 'absolute',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10
            })}>
            <Linear />
          </div>}
        <div
          {...imageStyles}
          ref={element => (this._imgContainer = element)}
          data-picture
          data-formats={JSON.stringify(cleanFormats(picture.formats))}
        />
      </div>
    );
  }
}

export class StaticPicture extends Picture {};

export default Relay.createContainer(Picture, {
  fragments: {
    picture: () => Relay.QL`
      fragment on Picture {
        url
        width
        height
        formats {
          url
          width
          height
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/images/Picture.js